export type StatusSeverity = 'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast';

interface StatusPresentation {
  readonly label: string;
  readonly severity: StatusSeverity;
}

const STATUS_PRESENTATION: Readonly<Record<string, StatusPresentation>> = {
  COMPLETED: { label: 'Concluído', severity: 'success' },
  RECEIVED: { label: 'Recebido', severity: 'success' },
  PAID: { label: 'Pago', severity: 'success' },
  CONFIRMED: { label: 'Confirmado', severity: 'info' },
  PENDING: { label: 'Pendente', severity: 'warn' },
  CANCELED: { label: 'Cancelado', severity: 'danger' },
  CANCELLED: { label: 'Cancelado', severity: 'danger' },
  REFUNDED: { label: 'Reembolsado', severity: 'warn' },
  FAILED: { label: 'Falhou', severity: 'danger' },
  DRAFT: { label: 'Rascunho', severity: 'secondary' },
  OVERDUE: { label: 'Vencido', severity: 'danger' },
  RECEIVED_IN_CASH: { label: 'Recebido em dinheiro', severity: 'success' },
  REFUND_REQUESTED: { label: 'Reembolso solicitado', severity: 'warn' },
  REFUND_IN_PROGRESS: { label: 'Reembolso em andamento', severity: 'warn' },
  CHARGEBACK_REQUESTED: { label: 'Chargeback solicitado', severity: 'danger' },
  CHARGEBACK_DISPUTE: { label: 'Chargeback em disputa', severity: 'danger' },
  AWAITING_CHARGEBACK_REVERSAL: { label: 'Aguardando reversão do chargeback', severity: 'warn' },
  DUNNING_REQUESTED: { label: 'Negativação solicitada', severity: 'warn' },
  DUNNING_RECEIVED: { label: 'Recuperado por negativação', severity: 'success' },
  AWAITING_RISK_ANALYSIS: { label: 'Em análise de risco', severity: 'warn' }
};

export function statusLabel(status: string): string {
  return STATUS_PRESENTATION[status]?.label ?? status;
}

export function statusSeverity(status: string): StatusSeverity {
  return STATUS_PRESENTATION[status]?.severity ?? 'info';
}
